import React, { Component } from 'react';
import { Dialog, DialogCloseButton } from '../Dialog';
import AddPlayerForm from '../AddPlayerForm';
import './styles.scss';

class AddUserDialog extends Component {
	render() {
		const { closeDialog, onUserCreated } = this.props;
		return (
			<Dialog className="AddUserDialog" closeDialog={closeDialog}>
				<DialogCloseButton closeDialog={closeDialog} />
				<AddPlayerForm onUserCreated={onUserCreated} />
			</Dialog>
		);
	}
}

export default AddUserDialog;
